import FuseAnimate from '@/@fuse/core/FuseAnimate';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import CustomPhoneInput from '@/app/customComponents/CustomPhoneInput/CustomPhoneInput';
import { uploadFile } from '@/app/services/imageUpload/imageUpload';
import {
	getCompany,
	createSchool,
	getCountryList,
	getSearchableCityList,
	getSearchableStateList,
} from '@/app/services/schools/schools';
import * as Actions from '@/app/store/actions';
import { getImageUrl, isImageFile, isInValidName, scrollIntoView } from '@/utils/utils';
import { Avatar, CircularProgress, FormControlLabel, FormHelperText, IconButton } from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { isPossiblePhoneNumber } from 'libphonenumber-js/min';
import { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import tz_lookup from 'tz-lookup';
import './AddSubAdmin.css';
import { useNavigate } from 'react-router-dom';

const AddSchools = () => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const inputRef = useRef(null);
	const user = useSelector(({ auth }) => auth.user);
	const [company, setCompany] = useState(null);
	const [companyLoaded, setCompanyLoaded] = useState(false);
	const [countries, setCountries] = useState([]);
	const [states, setStates] = useState([]);
	const [city, setCity] = useState([]);
	const [timeZone, setTimeZone] = useState({ city: '', state: '' });
	const [latLong, setLatLong] = useState({ lat: '', long: '' });
	const [cityTimezone, setCityTimeZone] = useState('');
	const tzlookup = tz_lookup;
	const [selectedFile, setSelectedFile] = useState(null);
	const [preview, setPreview] = useState(null);
	const [isStateloading, setIsStateloading] = useState(false);
	const [searchStateQuery, setStateSearchQuery] = useState('');
	const [isCityLoading, setIsCityLoading] = useState(false);
	const [searchCityQuery, setSearchCityQuery] = useState('');

	const [form, setForm] = useState({
		status: 1,
		is_owner: false,
		first_name: '',
		last_name: '',
		phone: '',
		email: '',
		school_phone: '',
		designation: '',
		school_name: '',
		state_id: '',
		timezone: '',
		address: '',
		street: '',
		country_code: '',
		city: '',
		zip_code: '',
	});
	const [admins, setAdmins] = useState([{ first_name: '', last_name: '', email: '', phone: '', designation: '' }]);
	const [isReq, setIsReq] = useState(false);
	const [errTxts, setErrTxts] = useState({
		first_name: '',
		last_name: '',
		email: '',
		phone: '',
		school_name: '',
		school_phone: '',
		address: '',
		street: '',
		country_code: '',
		state_id: '',
		city: '',
		zip_code: '',
		status: '',
	});

	useEffect(() => {
		if (!selectedFile) {
			setPreview(null);
			return;
		}

		const objectUrl = URL.createObjectURL(selectedFile);
		setPreview(objectUrl);

		return () => URL.revokeObjectURL(objectUrl);
	}, [selectedFile]);

	const onSelectFile = (e) => {
		if (!e.target.files || e.target.files.length === 0) {
			setSelectedFile(null);
			return;
		}
		const file = e.target.files[0];
		if (!isImageFile(file)) {
			dispatch(Actions.showMessage({ message: 'Please select an image file', variant: 'error' }));
		} else {
			setSelectedFile(e.target.files[0]);
		}
	};

	const toggleIsOwner = async (e) => {
		setForm({ ...form, is_owner: e.target.checked });
		if (e.target.checked) {
			let owner;
			if (!companyLoaded) {
				let response = await getCompany();
				setCompany(response.data);
				setCompanyLoaded(true);
				owner = response.data.owner;
			} else {
				owner = company?.owner;
			}
			setErrTxts({ ...errTxts, first_name: '', last_name: '', phone: '', email: '' });
			setAdmins([
				{
					first_name: owner.first_name ?? '',
					last_name: owner.last_name ?? '',
					phone: owner.phone ?? '',
					email: owner.email ?? '',
					designation: admins[0].designation || '',
				},
			]);
		}
	};
	const handleChange = (event, index) => {
		const { name, value } = event.target;
		if (name === 'first_name') {
			setErrTxts({ ...errTxts, first_name: '' });
			setAdmins([...admins.slice(0, index), { ...admins[index], [name]: value }, ...admins.slice(index + 1)]);
			return;
		}
		if (name === 'last_name') {
			setErrTxts({ ...errTxts, last_name: '' });
			setAdmins([...admins.slice(0, index), { ...admins[index], [name]: value }, ...admins.slice(index + 1)]);
			return;
		}
		if (name === 'phone') {
			setErrTxts({ ...errTxts, phone: '' });
			setAdmins([...admins.slice(0, index), { ...admins[index], [name]: value }, ...admins.slice(index + 1)]);
			return;
		}
		if (name === 'email') {
			setErrTxts({ ...errTxts, email: '' });
			setAdmins([...admins.slice(0, index), { ...admins[index], [name]: value }, ...admins.slice(index + 1)]);
			return;
		}
		if (name === 'designation') {
			setErrTxts({ ...errTxts, designation: '' });
			setAdmins([...admins.slice(0, index), { ...admins[index], [name]: value }, ...admins.slice(index + 1)]);
			return;
		}
		if (name === 'school_name') {
			setErrTxts({ ...errTxts, school_name: '' });
		}
		if (name === 'school_phone') {
			setErrTxts({ ...errTxts, school_phone: '' });
		}
		if (name === 'address') {
			setErrTxts({ ...errTxts, address: '' });
		}
		if (name === 'country_code') {
			setErrTxts({ ...errTxts, country_code: '' });
		}
		if (name === 'state_id') {
			setErrTxts({ ...errTxts, state_id: '' });
			const a = JSON.parse(value);
			setTimeZone({ ...timeZone, state: a });
			return;
		}
		if (name === 'city') {
			setErrTxts({ ...errTxts, city: '' });
			const a = JSON.parse(value);
			setTimeZone({ ...timeZone, city: a });
		}
		if (name === 'zip_code') {
			// Only Number, Max 5, can be empty
			if (value && !/^[0-9]{0,5}$/.test(value)) {
				return;
			}
			setErrTxts({ ...errTxts, zip_code: '' });
		}
		if (name === 'street') {
			setErrTxts({ ...errTxts, street: '' });
		}
		setForm({ ...form, [name]: value });
	};

	const isError = {
		first_name: false,
		last_name: false,
		email: false,
		phone: false,
		school_name: false,
		school_phone: false,
		address: false,
		street: false,
		country_code: false,
		state_id: false,
		city: false,
		zip_code: false,
	};
	const handleSubmit = (e) => {
		e.preventDefault();
		const data = JSON.parse(JSON.stringify(form));
		data.school_admin = admins[0];
		data.school_phone = form.school_phone;
		if (data.city) {
			data.timezone = cityTimezone;
		}

		// admin validations
		const adminStates = admins[0];
		if (!form.is_owner) {
			if (!adminStates?.first_name) {
				isError.first_name = true;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, first_name: 'This field is required.' }));
				scrollIntoView('fname-0');
			} else if (adminStates?.first_name && isInValidName(adminStates?.first_name)) {
				isError.first_name = true;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, first_name: 'Please enter a valid name.' }));
				scrollIntoView('fname-0');
			} else {
				isError.first_name = false;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, first_name: '' }));
			}
			// last_name validations
			if (!adminStates?.last_name) {
				isError.last_name = true;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, last_name: 'This field is required.' }));
				scrollIntoView('lname-0');
			} else if (adminStates?.last_name && isInValidName(adminStates?.last_name)) {
				isError.last_name = true;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, last_name: 'Please enter a valid name.' }));
				scrollIntoView('lname-0');
			} else {
				isError.last_name = false;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, last_name: '' }));
			}
			// email validations
			if (!adminStates?.email) {
				isError.email = true;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, email: 'This field is required' }));
				scrollIntoView('email-0');
			} else if (!/^\S+@\S+\.\S+$/.test(adminStates?.email)) {
				isError.email = true;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, email: 'Please enter valid email' }));
				scrollIntoView('email-0');
			} else {
				isError.email = false;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, email: '' }));
			}
			// phone validations
			if (!adminStates.phone) {
				isError.phone = true;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, phone: 'This field is required' }));
				scrollIntoView('phone-0');
			} else if (adminStates?.phone) {
				if (isPossiblePhoneNumber(adminStates.phone, 'US') === false) {
					isError.phone = true;
					setIsReq(false);
					setErrTxts((prevState) => ({ ...prevState, phone: 'Please enter valid phone number' }));
					scrollIntoView('phone-0');
				} else {
					isError.phone = false;
					setErrTxts((prevState) => ({ ...prevState, phone: '' }));
					setIsReq(false);
				}
			}
		}
		if (!adminStates?.designation) {
			isError.designation = true;
			setErrTxts((prevState) => ({ ...prevState, designation: 'This field is required.' }));
			scrollIntoView('designation-0');
		} else if (isInValidName(adminStates?.designation)) {
			isError.last_name = true;
			setErrTxts((prevState) => ({ ...prevState, designation: 'Please enter a valid name.' }));
			scrollIntoView('designation-0');
		} else {
			admins[0].designation = admins[0].designation.trim();
			isError.designation = false;
			setErrTxts((prevState) => ({ ...prevState, designation: '' }));
		}
		// school validations
		// school_name validations
		if (!form?.school_name) {
			isError.school_name = true;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, school_name: 'This field is required.' }));
		} else if (form?.school_name && /[^a-zA-Z0-9 ]/.test(form?.school_name)) {
			isError.school_name = true;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, school_name: 'Please enter a valid name.' }));
		} else {
			isError.school_name = false;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, school_name: '' }));
		}
		// school_phone validations
		if (!form.school_phone) {
			isError.school_phone = true;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, school_phone: 'This field is required' }));
		} else if (form?.school_phone) {
			if (isPossiblePhoneNumber(form.school_phone, 'US') === false) {
				isError.school_phone = true;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, school_phone: 'Please enter valid phone number' }));
			} else {
				isError.school_phone = false;
				setIsReq(false);
				setErrTxts((prevState) => ({ ...prevState, school_phone: '' }));
			}
		}
		// address validations
		if (!form?.address) {
			isError.address = true;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, address: 'This field is required.' }));
		} else {
			isError.address = false;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, address: '' }));
		}
		// country_code validations
		if (!form?.country_code) {
			isError.country_code = true;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, country_code: 'This field is required.' }));
		} else {
			isError.country_code = false;
			setErrTxts((prevState) => ({ ...prevState, country_code: '' }));
		}
		// state_id validations
		if (!form?.state_id) {
			isError.state_id = true;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, state_id: 'This field is required.' }));
		} else {
			isError.state_id = false;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, state_id: '' }));
		}
		// city validations
		if (!form?.city) {
			isError.city = true;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, city: 'This field is required.' }));
		} else {
			isError.city = false;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, city: '' }));
		}
		// zip_code validations
		if (!form?.zip_code) {
			isError.zip_code = true;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, zip_code: 'This field is required.' }));
		} else {
			isError.zip_code = false;
			setIsReq(false);
			setErrTxts((prevState) => ({ ...prevState, zip_code: '' }));
		}

		if (
			isError.first_name ||
			isError.last_name ||
			isError.email ||
			isError.phone ||
			isError.school_name ||
			isError.school_phone ||
			isError.address ||
			isError.street ||
			isError.country_code ||
			isError.state_id ||
			isError.city ||
			isError.zip_code ||
			isError.designation
		) {
		} else {
			data.company_id = user.data.school.id; // Company Id requested by Backend

			if (selectedFile) {
				const filename = getImageUrl(selectedFile);
				setIsReq(true);
				uploadFile(selectedFile, filename)
					.then((response) => {
						data.school_profile_image = `${import.meta.env.VITE_S3_BASE_URL}${response}`;
						createSchool(data, cityTimezone)
							.then(() => {
								dispatch(
									Actions.showMessage({
										message: 'School Successfully added.',
										autoHideDuration: 1500,
										variant: 'success',
									})
								);
								navigate('/schools');
							})
							.catch((err) => {
								setIsReq(false);
								dispatch(
									Actions.showMessage({
										message: 'Failed to add School',
										autoHideDuration: 1500,
										variant: 'error',
									})
								);
								if (err.response.data.errors) {
									setErrTxts(err.response.data.errors);
								}
							});
					})
					.catch(() => {
						setIsReq(false);
						dispatch(
							Actions.showMessage({
								message: 'Failed to add School',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
					});
			} else {
				setIsReq(true);
				createSchool(data, cityTimezone)
					.then(() => {
						dispatch(
							Actions.showMessage({
								message: 'School Successfuly added.',
								autoHideDuration: 1500,
								variant: 'success',
							})
						);
						navigate('/schools');
					})
					.catch((err) => {
						setIsReq(false);
						dispatch(
							Actions.showMessage({
								message: 'Failed to add School',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
						if (err.response.data.errors) {
							setErrTxts(err.response.data.errors);
						}
					});
			}
		}
	};

	useEffect(() => {
		if (latLong.lat !== '' && latLong.long !== '') {
			setCityTimeZone(tzlookup(latLong.lat, latLong.long));
		}
	}, [latLong]);

	useEffect(() => {
		let isMounted = true;
		const timeout = setTimeout(() => {
			if (!isMounted) return;
			setIsCityLoading(true);
			setForm({ ...form, city: '' });
			setCity([]);
			if (!searchCityQuery && !form.state_id) {
				setForm({ ...form, city: '' });
				setCity([]);
			} else {
				getSearchableCityList(form.state_id, searchCityQuery, 1)
					.then((res) => {
						if (!isMounted) return;
						setForm({ ...form, city: '' });
						setCity(res.data.data);
					})
					.catch(() => {
						if (!isMounted) return;
						dispatch(
							Actions.showMessage({
								message: 'Failed to get cities.',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
					})
					.finally(() => {
						if (!isMounted) return;
						setIsCityLoading(false);
					});
			}
		}, 1000);
		return () => {
			isMounted = false;
			clearTimeout(timeout);
		};
	}, [form.state_id, searchCityQuery]);

	useEffect(() => {
		let isMounted = true;
		const timeout = setTimeout(() => {
			if (!isMounted) return;
			setIsStateloading(true);
			setStates([]);
			setForm({ ...form, city: '' });
			setCity([]);
			if (!searchStateQuery) {
				getSearchableStateList('', '')
					.then((res) => {
						if (!isMounted) return;
						setStates(res.data.data);
						setForm({ ...form, city: '' });
						setCity([]);
					})
					.catch(() => {
						if (!isMounted) return;
						dispatch(
							Actions.showMessage({
								message: 'Failed to get states.',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
					})
					.finally(() => {
						if (!isMounted) return;
						setIsStateloading(false);
					});
			} else {
				getSearchableStateList(searchStateQuery, searchStateQuery ? undefined : 1)
					.then((res) => {
						if (!isMounted) return;
						setStates(res.data.data);
						setForm({ ...form, city: '' });
					})
					.catch(() => {
						if (!isMounted) return;
						dispatch(
							Actions.showMessage({
								message: 'Failed to get states.',
								autoHideDuration: 1500,
								variant: 'error',
							})
						);
					})
					.finally(() => {
						if (!isMounted) return;
						setIsStateloading(false);
					});
			}
		}, 1000);
		return () => {
			isMounted = false;
			clearTimeout(timeout);
		};
	}, [dispatch, form.country_code, searchStateQuery]);

	useEffect(() => {
		let isMounted = true;
		getCountryList()
			.then((res) => {
				if (!isMounted) return;
				setCountries(res.data);
			})
			.catch(() => {
				if (!isMounted) return;
				dispatch(
					Actions.showMessage({
						message: 'Failed to get countries.',
						autoHideDuration: 1500,
						variant: 'error',
					})
				);
			});
		return () => {
			isMounted = false;
		};
	}, []);


	return (
		<FuseAnimate animation="transition.slideLeftIn" duration={600}>
			<div className="m-auto">
				<div className="items-end mb-20 justify-between">
					<span className="">
						<IconButton
							onClick={() => {
								navigate(-1);
							}}
						>
							<img alt="filter" className="backBtn-img" src="assets/images/arrow-long.png" width="24px" />
						</IconButton>
					</span>
					<span className="text-pd-lg mr-59 hd-main " style={{ fontSize: '20px' }}>
						Add School
					</span>
					<div className="box-input">
						<h2 className="" style={{ fontSize: '18px', fontWeight: '700' }}>
							School Manager Info
						</h2>
						<div className="flex gap-x-52 mt-12">
							<div
								className="row-span-2 school-camera-holder"
								onClick={() => inputRef.current.click()}
								onKeyDown={(e) => {
									if (e.key === 'Enter' || e.key === ' ') {
										e.preventDefault();
										inputRef.current.click();
									}
								}}
								role="button"
								style={{ justifySelf: 'center' }}
								tabIndex={0}
							>
								<Avatar src={preview} style={{ width: 120, height: 120, cursor: 'pointer' }} />
								<div className="school-pp-overlay">
									<i className="fa fa-2x fa-camera" />
								</div>
								<input
									accept="image/*"
									className="hidden"
									id="image"
									name="file"
									onChange={onSelectFile}
									ref={inputRef}
									type="file"
								/>
							</div>
							<form id="add-school-form">
								<div>
									<FormControlLabel
										control={<Switch checked={form.is_owner} onChange={toggleIsOwner} />}
										label="Same as Owner"
									/>
								</div>
								{admins.map((_, index) => (
									<fieldset
										className={`${index !== 0 ? 'my-10 bg-grey-100 pt-4' : ''}  grid grid-cols-3 gap-64`}
										key={index}
									>
										{index !== 0 ? (
											<div className="flex justify-end">
												<button
													id={`remove-admin-${index}`}
													onClick={() => setAdmins([...admins.slice(0, index), ...admins.slice(index + 1)])}
													type="button"
												>
													<i className="fas text-[20px]" style={{ cursor: 'pointer' }} />
												</button>
											</div>
										) : null}
										<TextField
											disabled={form.is_owner}
											error={!!errTxts[`school_admins.${index}.first_name`] || !!errTxts.first_name}
											helperText={errTxts[`school_admins.${index}.first_name`] || errTxts.first_name}
											id={`fname-${index}`}
											label="First Name"
											name="first_name"
											onChange={(event) => handleChange(event, index)}
											required
											value={admins[index].first_name}
										/>
										<TextField
											disabled={form.is_owner}
											error={!!errTxts[`school_admins.${index}.last_name`] || !!errTxts.last_name}
											helperText={errTxts[`school_admins.${index}.last_name`] || errTxts.last_name}
											id={`lname-${index}`}
											label="Last Name"
											name="last_name"
											onChange={(event) => handleChange(event, index)}
											required
											value={admins[index].last_name}
										/>
										<TextField
											disabled={form.is_owner}
											error={!!errTxts[`school_admins.${index}.email`] || !!errTxts.email}
											helperText={errTxts[`school_admins.${index}.email`] || errTxts.email}
											id={`email-${index}`}
											label="Email Address"
											name="email"
											onChange={(event) => handleChange(event, index)}
											required
											value={admins[index].email}
										/>
										<CustomPhoneInput
											disabled={form.is_owner}
											error={!!errTxts[`school_admins.${index}.phone`] || !!errTxts.phone}
											helperText={errTxts[`school_admins.${index}.phone`] || errTxts.phone}
											label="Contact Number"
											name={`admins[${index}].phone`}
											onChange={(e) => {
												setAdmins([
													...admins.slice(0, index),
													{ ...admins[index], phone: e.target.value },
													...admins.slice(index + 1),
												]);
												setErrTxts({ ...errTxts, phone: '' });
											}}
											required
											value={admins[index].phone || ''}
										/>
										<TextField
											className="justify-end"
											error={!!errTxts[`school_admins.${index}.designation`] || !!errTxts.designation}
											helperText={errTxts[`school_admins.${index}.designation`] || errTxts.designation}
											id={`designation-${index}`}
											label="Designation"
											name="designation"
											onChange={(event) => handleChange(event, index)}
											required
											value={admins[index].designation}
										/>
									</fieldset>
								))}
								<fieldset className="mt-32">
									<h1 className="col-span-3" style={{ fontSize: '18px', fontWeight: '700' }}>
										School Info
									</h1>
									<div className="grid grid-cols-3 gap-48">
										<TextField
											className="justify-end"
											error={!!errTxts.school_name}
											helperText={errTxts.school_name}
											id="school-name"
											label="School Name"
											name="school_name"
											onChange={handleChange}
											required
											value={form.school_name}
										/>
										<CustomPhoneInput
											error={!!errTxts.school_phone}
											helperText={errTxts.school_phone}
											label="Contact Number"
											name="school_phone"
											onChange={handleChange}
											required
											value={form.school_phone}
										/>
										<TextField
											className="justify-end"
											error={!!errTxts.address}
											helperText={errTxts.address}
											id="school-address"
											label="Address 1"
											name="address"
											onChange={handleChange}
											required
											value={form.address}
										/>
										<TextField
											// error={!!errTxts.street}
											// helperText={errTxts.street}
											id="school-street"
											label="Address 2"
											name="street"
											onChange={handleChange}
											value={form.street}
										/>
										<FormControl error={!!errTxts.country_code} required>
											<InputLabel id="country_code_label">Country</InputLabel>
											<Select
												id="country_code"
												labelId="country_code"
												name="country_code"
												onChange={handleChange}
												value={form.country_code}
											>
												{countries.length ? (
													countries.map((country) => {
														return (
															<MenuItem key={country.id + 60} value={country.code}>
																<span id={country.code}>{country.name}</span>
															</MenuItem>
														);
													})
												) : (
													<MenuItem>Loading...</MenuItem>
												)}
											</Select>
											{errTxts.country_code ? <FormHelperText>{errTxts.country_code}</FormHelperText> : null}
										</FormControl>
										<Autocomplete
											autoComplete={false}
											clearOnBlur={false}
											disableClearable
											getOptionLabel={(option) => option.name}
											id="state-autocomplete"
											loading={isStateloading}
											loadingText="...Loading"
											name="state_id"
											onChange={(_e, v) => {
												setForm({ ...form, state_id: v?.id || '' });
											}}
											onInputChange={(e, value) => {
												setStateSearchQuery(value);
												if (value === '') {
													setForm({ ...form, state_id: '', city: '' });
												}
											}}
											options={states}
											renderInput={(params) => (
												<TextField
													{...params}
													autoComplete="off"
													error={!!errTxts.state_id?.length}
													helperText={errTxts.state_id}
													label="State"
													required
												/>
											)}
											renderOption={(option) => (
												<div className="flex" style={{ gap: 10 }}>
													<div>{option.name}</div>
												</div>
											)}
											sx={{ width: '100%' }}
										/>
										<Autocomplete
											autoComplete={false}
											clearOnBlur={false}
											disableClearable
											getOptionLabel={(option) => option.name}
											id="city-autocomplete"
											loading={isCityLoading}
											loadingText="...Loading"
											name="city"
											onChange={(_e, v) => {
												const value = JSON.parse(v?.meta);
												setLatLong({
													...latLong,
													lat: value.latitude,
													long: value.longitude,
												});
												setForm({ ...form, city: v?.name || '' });
											}}
											options={city}
											renderInput={(params) => (
												<TextField
													{...params}
													autoComplete="off"
													error={!!errTxts.city?.length}
													helperText={errTxts.city}
													label="City"
													onChange={(e) => {
														setSearchCityQuery(e.target.value);
														if (e.target.value === '') {
															setForm({ ...form, city: '' });
														}
													}}
													required
													style={{ width: 220 }}
												/>
											)}
											renderOption={(option) => (
												<div className="flex" style={{ gap: 10 }}>
													<div>{option.name}</div>
												</div>
											)}
											sx={{ width: '100%' }}
										/>
										<TextField
											error={!!errTxts.zip_code}
											helperText={errTxts.zip_code}
											id="school-zipcode"
											label="Zipcode"
											name="zip_code"
											onChange={handleChange}
											required
											value={form.zip_code}
										/>
										<FormControl required>
											<InputLabel id="state-label">Status</InputLabel>
											<Select
												id="school-status"
												labelId="status-label"
												name="status"
												onChange={handleChange}
												placeholder="Status"
												value={form.status}
											>
												<MenuItem selected value={1}>
													<span id="active">Active</span>
												</MenuItem>
												<MenuItem value={0}>
													<span id="inactive">Inactive</span>
												</MenuItem>
											</Select>
										</FormControl>
									</div>
								</fieldset>
								{/* <div className="flex align-center justify-center">
								<CustomButton variant="primary" type="submit" id="add-school-button">
									Add
								</CustomButton>
							</div> */}

								<div className="flex justify-center w-max mt-40" style={{ gap: '20px' }}>
									{isReq ? (
										<div className="flex align-center justify-center mr-128">
											<CircularProgress size={35} />
										</div>
									) : (
										<>
											<CustomButton
												onClick={() => {
													history.goBack();
												}}
												variant="secondary"
												width={140}
											>
												Cancel
											</CustomButton>
											<CustomButton id="add-school-button" onClick={handleSubmit} variant="primary" width={140}>
												Add
											</CustomButton>
										</>
									)}
								</div>
							</form>
						</div>
					</div>
				</div>
			</div>
		</FuseAnimate>
	);
};

export default AddSchools;
